import { replayerIcons } from './InterfaceControls.js'

export function replayerStageIsFullscreen(replayStage) {
  return document.fullscreenElement === replayStage
}

export function bindReplayerFullscreen(o) {
  let fullscreenButtonMode = ''
  function updateFullscreenButton() {
    const active = replayerStageIsFullscreen(o.replayStage)
    const mode = active ? 'exit' : 'enter'
    if (fullscreenButtonMode !== mode) {
      fullscreenButtonMode = mode
      o.btnFs.innerHTML = active ? replayerIcons.fullscreenExit : replayerIcons.fullscreen
    }
    if (active) {
      o.btnFs.setAttribute('aria-label', 'Exit fullscreen')
      o.btnFs.setAttribute('title', 'Exit fullscreen')
    } else {
      o.btnFs.setAttribute('aria-label', 'Fullscreen')
      o.btnFs.setAttribute('title', 'Fullscreen')
    }
  }

  function onFullscreenChange() {
    updateFullscreenButton()
    requestAnimationFrame(() => o.onLayoutAfterChange())
  }

  function onFsButtonClick() {
    if (!document.fullscreenElement) void o.replayStage.requestFullscreen()
    else void document.exitFullscreen()
  }

  document.addEventListener('fullscreenchange', onFullscreenChange)
  o.btnFs.addEventListener('click', onFsButtonClick)

  return {
    updateFullscreenButton,
    dispose() {
      document.removeEventListener('fullscreenchange', onFullscreenChange)
      o.btnFs.removeEventListener('click', onFsButtonClick)
    }
  }
}
